import { Color } from "./Color";
import { Font } from "./Font";
import { FontStyle } from "./FontStyle";
import { TextAlignKinds } from "./TextAlignKinds";
import { ITextAreaStyle } from "./ITextAreaStyle";
import { ColorSpecifiedFeature } from "./ColorSpecifiedFeature";

export class TextAreaStyle {
  constructor(
    public fontStyle: FontStyle = new FontStyle(new Color("#000000"), new Font("ＭＳ ゴシック", 9)),
    public paintStyle: ColorSpecifiedFeature = new ColorSpecifiedFeature(false, new Color("transparent")),
    public alignment: TextAlignKinds = TextAlignKinds.TopLeft
  ) {}

  clone(): TextAreaStyle {
    return new TextAreaStyle(
      this.fontStyle.clone(),
      this.paintStyle.clone(),
      this.alignment,
    );
  }

  static from(source: ITextAreaStyle): TextAreaStyle {
    if (!source) {
      return null;
    }
    return new TextAreaStyle(FontStyle.from(source.fontStyle), ColorSpecifiedFeature.from(source.paintStyle), source.alignment);
  }

  static to(source: TextAreaStyle): ITextAreaStyle {
    if (!source) {
      return null;
    }
    return {
      fontStyle: FontStyle.to(source.fontStyle),
      paintStyle: ColorSpecifiedFeature.to(source.paintStyle),
      alignment: source.alignment,
    };
  }
}
